module.exports = __webpack_public_path__ + "media/images/ssb_bgimage-abfead86.png";